import { Card, Typography, CircularProgress } from "@mui/material";
import { useAvgTicket } from "../../services/useAvgTicket";
import { FC } from "react";

interface Props {
  start_date: string;
  end_date: string;
}

const AvgTicketCard: FC<Props> = ({ start_date, end_date }) => {
  const { data, isLoading } = useAvgTicket({ start_date, end_date });

  return (
    <Card sx={{ p: 2, textAlign: "center" }}>
      <Typography variant="subtitle2" gutterBottom>
        Ticket médio
      </Typography>
      {isLoading ? (
        <CircularProgress size={32} />
      ) : (
        <Typography variant="h4">
          R$ {Number(data?.avg_ticket ?? 0).toFixed(2)}
        </Typography>
      )}
    </Card>
  );
};

export default AvgTicketCard;
